<template>
	<AppLayout :title="trans('menu.association.representative-rotations.register')">
		<Empty v-if="rotations.length === 0"/>
		<CardGrid v-else>
			<Card v-for="rotation in rotations">
				<Badge active class="place-self-start">{{ trans('admin.users.rotations.ends_at') }} {{ dayjs(rotation.ends_at).format(trans('general.dayjs.datetime')) }}</Badge>
				<CardTitle>{{ rotation.college.acronym }}</CardTitle>
				<CardSubtitle>{{ rotation.college.name }}</CardSubtitle>
				<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.representative-rotations.registrations.create', rotation.id)" class="place-self-start">
					{{ trans('Register') }}
				</Link>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/Empty.vue'
import {defineProps, ref, type Ref} from 'vue'
import Card from '@/Components/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/Badges/Badge.vue'
import CardGrid from '@/Components/Cards/CardGrid.vue'
import CardTitle from '@/Components/Cards/CardTitle.vue'
import CardSubtitle from '@/Components/Cards/CardSubtitle.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'

const props = defineProps<{
	rotations:Array<Rotation>,
}>()

const rotations:Ref<Array<Rotation>> = ref(props.rotations)
</script>